export const frequencyOptions = [
  { value: 1, label: 'Weekly' },
  { value: 2, label: 'Biweekly' },
  { value: 0, label: 'Daily' },
  { value: 3, label: 'Monthly' },
];

export const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const timeOptions = [...Array(22).keys()].slice(5).map(x => {
  let label;
  if (x < 12) {
    label = `${x}AM`;
  } else if (x === 12) {
    label = '12PM';
  } else {
    label = `${x - 12}PM`;
  }
  return { value: x.toString(), label };
});

export const WEEKLY = 1;
export const BIWEEKLY = 2;
export const DAILY = 0;
export const MONTHLY = 3;

export const WEDNESDAY = 3;

export const NINE_AM = '9';
